import { Controller } from "./helpers/controller";
import {ShowLoader} from "./utils/showLoader";

export class SpinnerControl extends Controller {

    private formModule = () => $('');

    private loader: JQuery = $('#loading-spinner')

    constructor(element: HTMLFormElement) {
        super(element);

        $(element).on('submit', (e) => {
            ShowLoader(this.loader);
        });
    }
    

}


